/**
 * Boundary de errores — Captura excepciones en el árbol React y muestra fallback
 * Exporta: ErrorBoundary
 * Invoca: ServerErrorPage (@/pages/error) como fallback por defecto
 * NO debe contener lógica de negocio ni llamadas a servicios.
 */
import { logger } from "@/lib/logger";
import { Component, ErrorInfo, ReactNode } from "react";
import { ServerErrorPage } from "@/pages/error";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  moduleName?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logger.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      const detail = this.props.moduleName
        ? `[${this.props.moduleName}] ${this.state.error?.message ?? "Error desconocido"}`
        : this.state.error?.message;

      return <ServerErrorPage errorDetail={detail} />;
    }

    return this.props.children;
  }
}
